import React, { useRef, useState } from 'react'
import { Alert } from '../../components'
import { useResizeObserver } from '../../hooks'

const PageLayout = ({ alerts = {}, children, className }) => {
    const alertsWrapperRef = useRef(null);
    const [alertsHeight, setAlertsHeight] = useState(0)

    useResizeObserver(alertsWrapperRef.current, (alertsDomReact) => {
        setAlertsHeight(alertsDomReact.height)
    })

    return (
        <div className={`page-layout ${className || ''}`} style={{ '--alerts-height': `${alertsHeight}px` }}>
            <div ref={alertsWrapperRef} className='page-alerts container'>
                {
                    Object.keys(alerts).map((id) => <Alert key={id} {...alerts[id]} />)
                }
            </div>
            <div className='page-container'>
                {children}
            </div>
        </div>
    )
}

export default PageLayout